import { ButtonBase } from "@mui/material";
import colors from "../../config/colors";
import { colorPalette } from "../../config/colorPalette";
import { ELEVATION } from "../../config/shadows";

// box = button size, icon = MUI icon size. MUI glyphs sit inside a padded 24px box
// (a chevron is only ~12px tall at 24px), so these are larger than Figma's 12px / 16px.
const SIZES = {
  md: { box: 32, icon: 20 },
  lg: { box: 40, icon: 24 },
};

const VARIANTS = {
  tinted: {
    backgroundColor: colorPalette.brand[100],
    color: colorPalette.brand[700],
  },
  ghost: {
    backgroundColor: "transparent",
    color: colorPalette.mercuryAlpha[65],
  },
  elevated: {
    backgroundColor: colors.white,
    color: colorPalette.mercuryAlpha[65],
    border: `1px solid ${colorPalette.mercuryAlpha[8]}`,
    boxShadow: ELEVATION,
  },
};

/**
 * IconButton
 *
 * Props:
 * - icon: React node (filled @mui/icons-material icon), sized by the button
 * - variant: tinted | ghost | elevated
 * - size: md (32px) | lg (40px)
 * - sx: extra styles, merged last
 * - aria-label: required, the button has no visible text
 * - anything else (onClick, disabled, ...) goes to the underlying button
 */
const IconButton = ({
  icon,
  variant = "tinted",
  size = "md",
  sx: sxOverride = {},
  ...rest
}) => {
  const { box, icon: iconSize } = SIZES[size] || SIZES.md;

  return (
    <ButtonBase
      {...rest}
      sx={{
        width: box,
        height: box,
        borderRadius: "12px",
        boxSizing: "border-box",
        fontSize: iconSize,
        "&.Mui-disabled": { opacity: 0.4 },
        "& svg": { fontSize: "inherit", width: "1em", height: "1em" },
        ...(VARIANTS[variant] || VARIANTS.tinted),
        ...sxOverride,
      }}
    >
      {icon}
    </ButtonBase>
  );
};

export default IconButton;
